module.exports = __webpack_public_path__ + "static/media/050.69e3d976.jpg";